module.exports = __webpack_public_path__ + "6c4a0dbc/img/SOURCERY_poweredby_web.9819842b.png";